import {BaseElementsAppPrefs} from "@/elements-shared/BaseElementsAppPrefs";

export class AppPrefs extends BaseElementsAppPrefs {

  private static instance: AppPrefs;

  static getInstance() {
    if (!this.instance) {
      this.instance = new AppPrefs();
    }
    return this.instance;
  }

  private constructor() {
    super();
  }
}
